//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { BenefitItem } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class BenefitList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, rightImg, benefits, className } = this.props;
    const componentClasses = classNames(styles.BenefitList, {
      [className]: className,
    });
    const available_benefits = benefits.filter(
      (given_benefits) => given_benefits.text != ''
    );
    return (
      <div className={componentClasses}>
        <div className={styles.Left}>
          <h3 className={styles.Title}>{title}</h3>
          <div className={styles.Description}>
            {available_benefits.map((benefit, key) => (
              <BenefitItem
                key={`benefit-${key}`}
                icon={benefit.icon}
                text={benefit.text}
                className={styles.BenefitItem}
              />
            ))}
          </div>
        </div>
        {rightImg}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(BenefitList);
